var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',[_c('span',[_vm._v(_vm._s(_vm.$t("menu.artPool")))]),_c('div',{staticClass:"header_hover_menu"},[_c('router-link',{attrs:{"to":"/art-pool/nft/gallery"}},[_vm._v(" "+_vm._s(_vm.$t("menu.artPoolSub.viewGallery"))+" ")]),_c('router-link',{attrs:{"to":"/art-pool/nft"}},[_vm._v(" "+_vm._s(_vm.$t("menu.artPoolSub.exhibit"))+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }